import { useContext, useState } from 'react';

import {
  hourlyHistoricalPath,
  weather as weatherApi,
  task as taskApi
} from 'utilities/api';
import catchCancel from 'helpers/catchCancel';
import usePopulateMapData from 'hooks/usePopulateMapData';
import { parseServerError } from 'helpers/errorHelpers';
import { Context } from 'components/Store';
import { FETCH_TYPES } from 'helpers/constants';
import { windDirections } from '../Task/Tabs/Details/Sections/weatherData';
import { getFeaturesCentroidCoordinates } from '../../Property/helpers/mapApiHelpers';

const { REACT_APP_AG_CLEAR_APP_ID, REACT_APP_AG_CLEAR_APP_KEY } = ({"REACT_APP_ENVIRONMENT":"prod","REACT_APP_MAPBOX_ACCESS_TOKEN":"pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsdWs5ZG1vNzA2azYyam1scHljMjNyc3kifQ.YBj-8NtAHftqXroxqmbxXw","REACT_APP_PRODUCTION_RECORDS_PRINT_INVOICES_DATASET_ID":"54c3b6f6-2c72-4751-9242-970645550d61","REACT_APP_Y_AND_P_PROFITABILITY_DATASET_ID":"de9af2ce-72cb-4d65-910f-98f80a4e959d","REACT_APP_NOTICE_OF_APPLICATION_EMBED_REPORT_ID":"279f565e-28c5-427d-8c3f-f6037c079ca0,54c1314c-6002-4d24-8ae4-7acf3873b780","REACT_APP_APPLIED_PRODUCTS_BY_FIELD_DATASET_ID":"0ea12e9c-f357-4c3a-9c95-90ad1af626c0","REACT_APP_AG_CLEAR_APP_ID":"e152930f","REACT_APP_CROPWISE_CONNECT_API_URL":"https://uat-api.databus.cropwise.com","REACT_APP_SMART_LOOK_REGION":"us","REACT_APP_MASTERLIST_PASSWORD":"jDPEU8Mda65BJwf7","REACT_APP_POWERBI_GROUP_ID":"aa609fd5-6c0e-48c7-8203-1a0f9964b4fa","REACT_APP_FIELDS_BY_FSA_WITH_MAP_EMBED_REPORT_ID":"bf5350d2-abc0-47ec-b3fc-dacdfdbaba45,7086f883-f064-4993-8164-34c24eef98c9","REACT_APP_APPLIED_PRODUCTS_DETAILS_EMBED_REPORT_ID":"cc2451cc-b8d7-453d-8bc5-1a9b6ba82dc3,e93dddc2-2e2f-4ed7-b38e-5d32d34dd665","REACT_APP_APPLICATOR_MAP_EMBED_REPORT_ID":"942dca38-db51-4840-9311-334a2dff6413,39ec099c-750a-4300-b1c4-72f70853cede","REACT_APP_FIELDS_BY_CROP_LAYOUT_DATASET_ID":"c917edaf-4774-455c-b8d6-30549ed9c2ef","REACT_APP_PRODUCTS_INVENTORY_SUMMARY_DATASET_ID":"9d62738f-e1f6-4f30-b458-256034ce5579","REACT_APP_FIELDS_BY_FSA_DATASET_ID":"4cfbd5b1-65aa-4e51-b2e2-99da03246f63","REACT_APP_APPLIED_PRODUCTS_SUMMARY_EMBED_REPORT_ID":"2f089bdb-f1fc-4bb4-9947-fb77ff83c363,85d7757d-fa9e-44bc-9e70-5ba18f1b570f","REACT_APP_DEVTEST_ORGANIZATIONID":"9a1a1673-6926-41fa-9d71-a5aad6f67cb6","REACT_APP_APPLIED_PRODUCTS_DICAMBA_EMBED_REPORT_ID":"117e0640-4b78-48bf-b39b-35aa45e0a1ab,04db8ed6-4706-49cf-a0da-28266e6f163e","REACT_APP_PROPERTIES_BY_CROP_ZONE_INFO_EMBED_REPORT_ID":"da7f9f78-1733-4aba-8022-0bf62b75e59d,ff873157-cf8b-4c40-975c-c24ae0835e93","REACT_APP_PRODUCTION_RECORDS_PRINT_PLANS_DATASET_ID":"7c84d00a-e5f0-4795-966a-62c7c4967133","REACT_APP_CLIENT_ID":"a242e108fe8742bbb221c90b22ffb722","REACT_APP_SENTRY_SAMPLE_RATE":"0.1","REACT_APP_APPLIED_PRODUCTS_FERTILIZER_BY_CROP_EMBED_REPORT_ID":"4cd22d55-58b2-4783-a7f7-8b13aaa2c4fb,6cf9f3d7-2e8c-45f9-b6fc-1eb66bc24ffc","REACT_APP_APPLIED_PRODUCTS_REI_DATASET_ID":"1517bea0-13bd-414d-95ec-804ce3114e78","REACT_APP_PESTICIDE_USAGE_BY_CROP_DATASET_ID":"d6ed96ff-3a9d-490f-ab21-7c7837f995cd","REACT_APP_APPLIED_PRODUCTS_PHI_DATASET_ID":"bfc8f62d-2f13-4649-837f-df5e2dfccba2","REACT_APP_PRODUCTION_RECORDS_PRINT_INVOICES_EMBED_REPORT_ID":"c459a2c5-bfec-458f-97f4-7ea7288fe2b3,354e8a96-222a-4ddd-9ef3-6d80a3471b70","REACT_APP_Y_AND_P_PROFITABILITY_EMBED_REPORT_ID":"c4e457da-9781-4f74-bc4b-1955ebc59573,4e3dc1a2-0eb6-4c23-b900-84940da809ae","REACT_APP_APPLIED_PRODUCTS_BY_REGULATORY_EMBED_REPORT_ID":"ca205366-567f-4e3e-a0b9-aab1775ccffe","REACT_APP_PRODUCTION_RECORDS_PRINT_RECOMMENDATIONS_DATASET_ID":"2983e519-2b11-43ac-af6a-01881d536bcd","REACT_APP_REMOVE_LATER_EMPTY_ID":"","REACT_APP_CROPWISE_PROXY_V2_URL":"https://api-v2-prod.financials.cropwise.com","REACT_APP_HIDE_PROPERTIES":"true","REACT_APP_APPLIED_PRODUCTS_BY_FIELD_EMBED_REPORT_ID":"184adc46-86ee-4971-8e8d-75f2889a66fc,b745d25c-e58a-439f-ac25-514fd4d689ec","REACT_APP_MASTERLIST_PROXY_URL":"https://masterlist-proxy-api.landdb.com/api","REACT_APP_CROPWISE_PROXY_URL":"https://api-prod.financials.cropwise.com","REACT_APP_PRODUCTION_RECORDS_PRINT_TASKS_DATASET_ID":"588c21f1-1e01-4563-9218-8bcfcdec58a5","REACT_APP_PRODUCTS_PLAN_SUMMARY_DATASET_ID":"34ea4204-a5ce-49d0-8fcc-30ad14568c86","REACT_APP_SENTRY_DSN":"https://3dc4f6ed59a640eda9f9af2aba42b0f2@o49647.ingest.sentry.io/6555748","REACT_APP_AG_CLEAR_APP_ROOT_URL":"https://ag.us.clearapis.com","REACT_APP_AG_CLEAR_APP_KEY":"c8680d7e198295202a7bd1838a5cd76d","REACT_APP_Y_AND_P_YIELD_PRODUCTION_DATASET_ID":"ff1719de-48f1-4131-8749-9546a29e6905","REACT_APP_SENTRY_TOKEN":"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","REACT_APP_AMPLITUDE_KEY":"74f6eef8a89f32a50d56aff0c2743ace","REACT_APP_FIELDS_BY_FSA_EMBED_REPORT_ID":"1d6cb438-00c5-4ede-ae02-4dcf12c7a1c4,ba0e672f-9b1b-4437-9908-6fa60355d748","REACT_APP_PRODUCTS_INVENTORY_SUMMARY_EMBED_REPORT_ID":"1f0fcdf3-2fae-4133-96d7-387b1fba41bc,cf6462c2-230a-4cd4-bd68-c18046512529","REACT_APP_FIELDS_BY_CROP_LAYOUT_EMBED_REPORT_ID":"8771c593-b65f-4e10-8132-3eeeac98906c,ed826eed-9477-4ca4-a221-a610b1417a22","REACT_APP_HIDE_PRODUCTS":"false","REACT_APP_SIMPLOT_REDIRECT_OAUTH_URL":"https://onelogin.agcocorp.com/051b9332-1f85-46f9-87be-a6ea3157fd86/oauth2/v2.0/authorize?p=b2c_1a_signin_ptx&scope=offline_access+openid+{clientId}&client_id={clientId}&redirect_uri={redirect}&response_type=code","REACT_APP_SMART_LOOK_KEY":"2e4e8daf83c4937253a99516982b6482e03be4f5","REACT_APP_ENV_NAME":"prod","REACT_APP_HOST_URL":"https://financials.cropwise.com","REACT_APP_PRODUCTION_RECORDS_PRINT_PLANS_EMBED_REPORT_ID":"4ce2a492-cc3b-4ef2-aa91-ae5f9ba7138b,3e1793b6-8310-49a2-a3b7-03224233e5fe","REACT_APP_ROLE_CONTEXT_PERMISSIONS_UPDATE":"app:6a64f9eb-4543-4944-a2ed-11a356f4dee2","REACT_APP_BASE_AUTH_HEADER":"YTI0MmUxMDhmZTg3NDJiYmIyMjFjOTBiMjJmZmI3MjI6","REACT_APP_EXCEL_REPORT_DATASET_ID":"e364e1e7-8c07-4d00-93b0-0e4aa4f69492","REACT_APP_LOG_LEVEL":"ALL","REACT_APP_INTEGRATIONS_CALAG_WEBSITE":"https://www.calagpermits.org","REACT_APP_APPLIED_PRODUCTS_BY_CROP_DETAILS_DATASET_ID":"1d8ed7b7-35c6-4083-af36-70f08b1e01b0","REACT_APP_APPLIED_PRODUCTS_SUMMARY_DETAILS_DATASET_ID":"617e9c70-5142-4a9e-abf1-137eb7215738","REACT_APP_APPLIED_PRODUCTS_REI_EMBED_REPORT_ID":"d47c6cc5-bd50-48cc-97e9-454abf8ac8fc,68c21345-0ce9-4f5f-b0e5-61c546405a31","REACT_APP_APPLIED_PRODUCTS_REGULATORY_DATASET_ID":"8c81c82b-8e68-4a2d-9473-4cad9dcbf081","REACT_APP_SMART_LOOK_VERSION":"nextgen","REACT_APP_APPLIED_PRODUCTS_PHI_EMBED_REPORT_ID":"c5608429-1ab7-4e37-ac8d-b9e7db53a9ad,fbdae22a-f2cb-41f1-b6bc-5a3f8b33fb73","REACT_APP_MASTERLIST_USERNAME":"cwf_ml","REACT_APP_CAMPAIGN_LINK":"https://accounts.cropwise.com/signup?source_campaign=MTZmMGU0Y2ItMGU4MS00NGY5LTliN2QtYzc4NDdjOGQ1NGZjOjphODI2NzBmZi0wYzI5LTRjZWYtYTg4Mi0wMGZiNWU5ZWY5ODQ6OkNyb3BXaXNl&redirect_uri=https://financials.cropwise.com/authenticate&client_id=a242e108fe8742bbb221c90b22ffb722","REACT_APP_PRODUCTION_RECORDS_PRINT_RECOMMENDATIONS_EMBED_REPORT_ID":"e47d7163-6aa8-4a99-90d2-6709b9f7954f,66824383-2207-47a3-afbe-98a7ff103006","REACT_APP_ORG_INVITE_REDIRECT_PROD_URL":"https://financials.cropwise.com","REACT_APP_APPLIED_PRODUCTS_BY_DAY_DATASET_ID":"6b3a3cc8-6795-4abb-9700-f23e71656e1a","REACT_APP_WEATHER_API_KEY":"744ef8cc-ca82-40c1-afcd-069f9d995ede","REACT_APP_LC_CLIENT_KEY":"6384e10156c30611b231c458","REACT_APP_NOTICE_OF_APPLICATION_DATASET_ID":"6e265b11-ac2b-4703-8b68-915bd2801e5e","REACT_APP_PRODUCTS_PLAN_SUMMARY_EMBED_REPORT_ID":"015d142a-cfd5-4b25-83c7-74e577961964,57e9a662-64da-48c4-8683-40ab6d66da1d","REACT_APP_SEGMENT_SOURCE_ID":"7EfMqzDYRfDzoqjfSlAMCsP0hjNA3fJD","REACT_APP_PRODUCTION_RECORDS_PRINT_TASKS_EMBED_REPORT_ID":"3cfe068c-1ce2-403a-8a4f-a61187a445a9,95cc0bbb-048c-49c1-88f5-cee0f8f2c8f5","REACT_APP_DATADOG_CLIENT_TOKEN":"pubff56a53222bfbe3533aeffaef12cf643","REACT_APP_Y_AND_P_YIELD_PRODUCTION_EMBED_REPORT_ID":"5825d5a4-9e3e-4852-b354-05932e1cb0fc,07638692-2dd8-4607-98a6-7aee5fe3f5ac","REACT_APP_CROPWISE_BASE_API_CROPS":"api.base.cropwise.com","REACT_APP_AG_CLEAR_APP_HOURLY_HISTORICAL_PATH":"historical/hourly","REACT_APP_DATADOG_APP_ID":"4bcdf6fe-4d2a-4ca5-b274-7b6a9b8dba8e","REACT_APP_SIMPLOT_CLIENT_ID":"26394ba9-f253-46a0-b013-f84bd22e338c","REACT_APP_AG_CLEAR_APP_HOURLY_FORECAST_PATH":"forecast/hourly","REACT_APP_APPLIED_PRODUCTS_BY_FIELD_EXPORT_REPORT_ID":"2ed1e364-74a7-4b7e-a71d-5e1b402f8766","REACT_APP_APPLIED_PRODUCTS_DETAILS_DATASET_ID":"1c052371-e1dc-4c9a-91e1-75d7561f54cc","REACT_APP_FIELDS_BY_FSA_WITH_MAP_DATASET_ID":"654dad9d-145f-4e67-9e03-30f7adbf882e","REACT_APP_APPLICATOR_MAP_DATASET_ID":"11a17ce1-95bb-48bc-b08b-d358dded6767","REACT_APP_PESTICIDE_USAGE_EMBED_REPORT_ID":"fc0c2dbd-a0b2-4662-a7ca-ee383d107092,5858b9e8-3a99-4aa7-bfe7-4cf13a63c890","REACT_APP_APPLIED_PRODUCTS_BY_CROP_DETAILS_EMBED_REPORT_ID":"90363f02-26bc-4245-9e8a-765951baaf84,7b36b0b4-3753-4c98-9a4f-e1f6ad69bd70","REACT_APP_HIDE_PROPERTIESV2":"false","REACT_APP_APPLIED_PRODUCTS_DICAMBA_DATASET_ID":"e60f2526-0cf3-445d-8d52-025c61c4d711","REACT_APP_EXCEL_REPORT_EMBED_REPORT_ID":"648586d0-7e8d-4def-a5e9-6f6db63a278f,d5037e2a-7eff-4bec-a40e-f582c9cabdef","REACT_APP_FIELDS_BY_CROP_LAYOUT_EXPORT_REPORT_ID":"ed826eed-9477-4ca4-a221-a610b1417a22","REACT_APP_PROPERTIES_BY_CROP_ZONE_INFO_DATASET_ID":"e5814ee9-24cf-4f34-9beb-3784ee1ddd8a","REACT_APP_APPLIED_PRODUCTS_REGULATORY_EMBED_REPORT_ID":"9d2fe57b-f404-45d3-b0a8-4eb9a33bbda2,2faf5079-a74c-4450-9d6b-e3f808739b62","REACT_APP_SIMPLOT_REDIRECT_AUTHORIZE_ORG_URL":"https://www.farmengage.com/ThirdPartyAccess/ThirdPartyAuthorizationRedirect?clientid={clientId}&redirectionUrl={redirect}&IsAgcoId=true","REACT_APP_APPLIED_PRODUCTS_BY_DAY_EMBED_REPORT_ID":"111b69f0-aab5-4056-85d5-0694aa5bd999,7e6db259-1e63-4a99-9e52-b04e04e4729d","REACT_APP_HIDE_INVOICES":"false","REACT_APP_BASE_API":"https://api.base.cropwise.com","REACT_APP_APPLIED_PRODUCTS_FERTILIZER_BY_CROP_DATASET_ID":"0188f191-2c08-47b6-94db-f186c5a1bf55","REACT_APP_CROPWISE_BASE_API_URL":"accounts.cropwise.com","REACT_APP_ENV":"production","NODE_ENV":"production","PUBLIC_URL":""});

const useWeatherData = () => {
  const [context, dispatch] = useContext(Context);
  const { weatherAutomaticToggle } = context;
  const { fieldsAndAreasCentroidCoordinates } = usePopulateMapData({
    fetchType: FETCH_TYPES.propertiesMap
  });
  const [updating, setUpdating] = useState(false);

  const TaskWeatherObj = {
    date: '',
    dateEpoch: '',
    temperature: '',
    temperatureUnit: '',
    humidity: '',
    skyCondition: '',
    windSpeed: '',
    windSpeedUnit: '',
    windDirection: '',
    soilMoisture: '',
    type: ''
  };

  const DefaultWeatherData = [
    {
      date: '',
      temperature: '',
      temperatureUnit: 'F',
      humidity: '',
      skyCondition: '',
      windSpeed: '',
      windSpeedUnit: 'MPH',
      windDirection: '',
      soilMoisture: 'unknown',
      type: 'start'
    },
    {
      date: '',
      temperature: '',
      temperatureUnit: 'F',
      humidity: '',
      skyCondition: '',
      windSpeed: '',
      windSpeedUnit: 'MPH',
      windDirection: '',
      soilMoisture: 'unknown',
      type: 'end'
    }
  ];

  const getNumericValue = field => {
    const fieldData = field || '';
    const matches = fieldData.match(/(\d+)/);
    return matches && matches?.length > 0 ? field.match(/(\d+)/)[0] : '';
  };

  const checkForValidWindDirection = firstHourlyResult => {
    // depending on when the weather data is pulled the results set can return a different wind direction object
    const windDirection =
      firstHourlyResult?.descriptors?.wind_direction_descriptor ||
      firstHourlyResult?.descriptors?.wind_direction;
    const resultWD = windDirections.filter(
      wd => wd.code === windDirection?.code
    );
    return resultWD.length === 0
      ? windDirections.filter(dir => dir.key === 'unknown')[0].value
      : resultWD[0]?.value;
  };

  const setWeatherObj = (index, firstHourlyResult, startDateTimeStamp) => ({
    date: new Date(startDateTimeStamp * 1000),
    dateEpoch: startDateTimeStamp * 1000,
    temperature: firstHourlyResult?.air_temp?.value || '',
    temperatureUnit: firstHourlyResult?.air_temp?.unit || '',
    humidity: firstHourlyResult?.relative_humidity?.value || '',
    skyCondition:
      firstHourlyResult?.descriptors?.weather_descriptor?.text || '',
    windSpeed: firstHourlyResult?.wind_speed?.value || '',
    windSpeedUnit: firstHourlyResult?.wind_speed?.unit?.toUpperCase() || '',
    windDirection: checkForValidWindDirection(firstHourlyResult) || '',
    soilMoisture: 'unknown',
    type: index === 0 ? 'start' : 'end'
  });

  const getCoordinates = (id, values, fieldsAndAreasGeoJSONCollection) => {
    let coordinates;
    if (
      (id === 'create' || id === 'convert' || id === 'duplicate') &&
      values?.properties?.features?.length > 0
    ) {
      const allFeatures = values?.properties?.map(
        property => property.features[0]
      );
      const featureCentroidCoordinates = getFeaturesCentroidCoordinates(
        allFeatures
      );
      coordinates = [...featureCentroidCoordinates];
      // setCoordinates([...featureCentroidCoordinates]);
    } else {
      const tempData = values?.properties?.map(property =>
        fieldsAndAreasGeoJSONCollection?.features?.find(
          feature =>
            property.farmId === feature.properties.propertyId &&
            feature.properties.$landType === 'field'
        )
      );
      if (
        tempData.length > 0 &&
        fieldsAndAreasGeoJSONCollection?.features?.length > 0
      ) {
        const featureCentroidCoordinates = getFeaturesCentroidCoordinates(
          tempData
        );
        coordinates = [...featureCentroidCoordinates];
        // setCoordinates([...featureCentroidCoordinates]);
      }
    }

    return coordinates;
  };

  const isStartWeather = index => {
    return index === 0;
  };

  const isEndWeather = index => {
    return index === 1;
  };

  const fetchURLDetails = (
    startDate,
    startDateEpoch,
    duration,
    index,
    id,
    dueDate
  ) => {
    let startDateTimeStamp;
    // only historical data is to used.  no data will be gathered for future dates.
    if (isStartWeather(index)) {
      if (id === 'create' || id === 'convert' || id === 'duplicate')
        startDateTimeStamp = startDate?.getTime() / 1000;
      else startDateTimeStamp = startDateEpoch / 1000;
    } else if (isEndWeather(index)) {
      if (duration !== 'Custom') {
        const taskDuration = Number(duration) * 3600;
        startDateTimeStamp = startDate?.getTime() / 1000 + taskDuration; // Hour 0 represents the current hour.
      } else {
        startDateTimeStamp = dueDate?.getTime() / 1000;
      }
    } else {
      throw new Error('Unexpected weather index :', index);
    }
    const endDateTimeStamp = startDateTimeStamp + 30;
    return {
      hourlyHistoricalPath,
      startDateTimeStamp,
      endDateTimeStamp,
      index
    };
  };

  const fetchClearAppWeatherData = async (
    startDate,
    coordinates,
    urlDetails,
    updateWeather
  ) => {
    const [longitude, latitude] = coordinates;
    const { path, startDateTimeStamp, endDateTimeStamp } = urlDetails;
    // Only displays ClearApp data when date is selected by user.
    if (startDate?.getTime() < Date.now()) {
      await fetch(
        `${path}?app_id=${REACT_APP_AG_CLEAR_APP_ID}&app_key=${REACT_APP_AG_CLEAR_APP_KEY}&end=${endDateTimeStamp}&location=[(${latitude},${longitude})]&start=${startDateTimeStamp}`
      )
        .then(async response => {
          if (response.status >= 200 && response.status <= 299) {
            return response.json();
          }
          const text = await response.text();
          throw new Error(text);
        })
        .then(result => {
          const locationResult = result[`${latitude},${longitude}`];
          const firstHourlyResult =
            locationResult[Object.keys(locationResult)[0]];
          updateWeather(firstHourlyResult, startDateTimeStamp);
        })
        .catch(catchCancel)
        .catch(error => {
          parseServerError(dispatch)(error);
        });
    }
  };

  const fetchClearAppWeatherDataReturn = async (
    startDate,
    coordinates,
    urlDetails
  ) => {
    let data = {};
    const [longitude, latitude] = coordinates;
    const { startDateTimeStamp, endDateTimeStamp } = urlDetails;
    // Only displays ClearApp data when date is selected by user.
    if (startDate?.getTime() < Date.now()) {
      const weatherLandingApi = weatherApi.createChildApi({
        action: `?app_id=${REACT_APP_AG_CLEAR_APP_ID}&app_key=${REACT_APP_AG_CLEAR_APP_KEY}&end=${endDateTimeStamp}&location=[(${latitude},${longitude})]&start=${startDateTimeStamp}`
      });
      const { promise } = weatherLandingApi.fetch();
      data = await promise
        .then(result => {
          const locationResult = result.data[`${latitude},${longitude}`];
          const firstHourlyResult =
            locationResult[Object.keys(locationResult)[0]];
          return firstHourlyResult;
        })
        .catch(catchCancel)
        .catch(error => {
          parseServerError(dispatch)(error);
        });
    }
    return data;
  };

  const updateTaskWeather = async (task, status) => {
    if (status === 'complete' && weatherAutomaticToggle) {
      setUpdating(true);
      // let updatedTask;
      const taskWeatherArray = [];
      // get the weather object from the task or if none get a couple of emtpy objects
      const weatherArray = [TaskWeatherObj, TaskWeatherObj];

      for (let i = 0; i < weatherArray.length; i += 1) {
        // get url data
        const urlData = fetchURLDetails(
          new Date(task?.startDate),
          task?.startDateEpoch,
          task?.duration,
          i,
          task?.id,
          new Date(task?.dueDate)
        );

        // get weather data from api
        // eslint-disable-next-line no-await-in-loop
        const taskWeatherObj = await fetchClearAppWeatherDataReturn(
          new Date(urlData.startDateTimeStamp),
          fieldsAndAreasCentroidCoordinates,
          urlData
        );

        // format weather data for the task save
        const formattedWeatherObj = setWeatherObj(
          i,
          taskWeatherObj,
          urlData.startDateTimeStamp
        );

        // add to the array
        taskWeatherArray.push(formattedWeatherObj);
      }

      // update task with new weather array
      const updatedTask = {
        ...task,
        applicationStrategy: 'ratearea',
        weather: taskWeatherArray
      };

      const { promise } = await taskApi.update(task.taskId, updatedTask);
      await promise.catch(catchCancel).catch(err => {
        parseServerError(dispatch)(err);
      });

      setUpdating(false);
    }
  };

  return {
    setWeatherObj,
    updateTaskWeather,
    fetchClearAppWeatherData,
    fetchClearAppWeatherDataReturn,
    fetchURLDetails,
    getCoordinates,
    getNumericValue,
    checkForValidWindDirection,
    TaskWeatherObj,
    DefaultWeatherData,
    updating
  };
};

export default useWeatherData;
